
export enum HelpTabList {
    FAQS = "FAQs",
    VIDEOS = "Videos",
    SUPPPORT_TICKETS = "Support Tickets",
}